import { useId } from '@hooks/use-id'
import React, { type FC } from 'react'

export const withDataId = (Component: FC<any>): FC => {
  const ComponentWithDataId: FC = (props) => {
    const id = useId()

    return <Component {...props} data-id={id} />
  }

  return ComponentWithDataId
}
